import { render, staticRenderFns } from "./CreateNewVMContractV2.vue?vue&type=template&id=587dd445&scoped=true&"
import script from "./CreateNewVMContractV2.vue?vue&type=script&lang=js&"
export * from "./CreateNewVMContractV2.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewVMContractV2.vue?vue&type=style&index=0&id=587dd445&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587dd445",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
